






































































import Vue from "vue";
import { AuthService, UserManagerService } from "@/common/api";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import { namespace } from "vuex-class";
import QErrors from "@/common/qErrors.vue";
import defineAbilityFor from "@/services/ability";

const auth = namespace("Auth");

@Component({
  name: "Invited",
  components: {
    QErrors,
  },
})
export default class Invited extends Vue {
  @auth.Getter
  getUsingGroup!: string;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateRefreshToken!: (refreshToken: string) => void;
  @auth.Action
  fetchCurrentUser!: () => void;
  @auth.Action
  updateUsingGroup!: (id: string) => void;

  public token = "";
  public groupId = "";
  public password = "";
  public errors = {};
  public isCompleted = false;
  public user: any = {};

  public errorStyle = {
    maxWidth: "100%",
  };

  mounted() {
    this.token = this.$route.params.token;
    this.groupId = this.$route.params.group_id;
    this.isCompleted = false;
    this.getUser();
  }

  public async getUser() {
    let result;
    try {
      result = await UserManagerService.adminUserInvitedUser({
        token: this.token,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      this.user = result.data.user;
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public async registPassword() {
    this.errors = {};
    let result;

    try {
      result = await UserManagerService.adminUserRegistPassword({
        token: this.token,
        password: this.password,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      this.isCompleted = true;
      await this.login();
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public async login() {
    let response: any;
    try {
      response = await AuthService.authLogin({
        email: this.user.email,
        password: this.password,
        group_id: Number.parseInt(this.groupId),
      });
    } catch (error: any) {
      response = error.body;
    }

    if (response.status == "error") {
      QNotify.error({
        text: response.body.message,
      });
      return;
    }

    const user = response.data.user;

    // Save it to state
    this.updateToken(response.data.token);
    this.updateRefreshToken(response.data?.refresh_token);
    this.updateUsingGroup(response.data.group_id);
    await this.fetchCurrentUser();

    // Set ability
    this.$ability.update(defineAbilityFor(user.role).rules);
  }

  public redirectPage() {
    this.$router.push({ name: "admin.info" });
  }
}
